<template>
    <div class="mb-4">
        <p>Học viên có làm bài hay không?</p>
        <el-radio v-model="didStudentDo.value" :label="false" :disabled="isView" @change="emitNotDone(false)">Không</el-radio>
        <br>
        <el-radio v-model="didStudentDo.value" :label="true" :disabled="isView" @change="emitNotDone">Có</el-radio>
    </div>
</template>
<script>
export default {
    name: "CheckHasTest",
    props: {
        isView: {
            type: Boolean,
            default() {
                return false
            }
        },
        didStudentDo: {
            type: Object,
            default() {
                return { value: true }
            }
        }
    },
    data() {
        return {
            notDone: true,

        }
    },
    methods: {
        emitNotDone(value = true) {
            if (!value) {
                this.$emit('handleNotDone')
            }

        }
    }
}
</script>